import { AlarmDetailsExpandedState } from '@/model/AlarmModel';
import { ReadOutlined, SnippetsOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { EllipsisConfig } from 'antd/lib/typography/Base';
import cx from 'classnames';
import React from 'react';
import { User } from '../../../../model/AccountModel';
import { AlarmQueueTreeNode } from '../../../../model/GraphicModel';
import { useStoreDispatch } from '../../../../store';
import { setShowAlarmDetails } from '../../../../store/alarm/actions';
import styles from '../alarmQueue.module.scss';

const user: User = getUser();
const { alwaysShowInstructions } = user;

const { Paragraph } = Typography;

type Props = {
	data: Partial<AlarmQueueTreeNode>;
};

const AlarmContent = ({ data }: Props) => {
	const dispatch = useStoreDispatch();

	let customShowMore = false;
	let instructions: string = data.Instructions;
	const hasInstructions: boolean = instructions !== '';
	const showInstructionsRow: boolean = hasInstructions && alwaysShowInstructions;
	const hasNotes: boolean = data.AlarmDetails[0].AlarmNotes && data.AlarmDetails[0].AlarmNotes?.length > 0;
	const descriptionClassName = data.ReturnedToNormal ? styles.returnToNormal : styles.active;

	const handleOnOpenNote = e => {
		e.stopPropagation();
		dispatch(setShowAlarmDetails({ alarmModel: data, showAlarmDetailsExpandedState: AlarmDetailsExpandedState.Notes }));
	};

	const handleOnOpenInstructions = e => {
		e.preventDefault();
		e.stopPropagation();
		dispatch(setShowAlarmDetails({ alarmModel: data, showAlarmDetailsExpandedState: AlarmDetailsExpandedState.Instructions }));
	};

	const showMoreButton = (
		<span className={styles.showMore} onClick={handleOnOpenInstructions}>
			{_('ShowMore')}
		</span>
	);

	const instructionsEllipsisConfig: EllipsisConfig = {
		rows: 1,
		expandable: true,
		symbol: showMoreButton,
	};

	const descriptionEllipsisConfig: EllipsisConfig = {
		rows: 1,
		tooltip: { title: data.Description, placement: 'right' },
	};

	if (showInstructionsRow) {
		const breakSpace: string[] = instructions.split('\r\n\r\n');
		if (breakSpace.length > 1) {
			customShowMore = true;
			instructions = breakSpace[0];
		}
	}

	return (
		<div>
			<div className={cx(styles.alarmRow)}>
				{hasNotes && <SnippetsOutlined className={styles.noteIcon} onClick={handleOnOpenNote} />}
				{hasInstructions && !alwaysShowInstructions && <ReadOutlined className={styles.instructionIcon} onClick={handleOnOpenInstructions} />}
				<Paragraph className={cx(styles.text, descriptionClassName)} ellipsis={descriptionEllipsisConfig}>
					<span>{data.Description}</span>
				</Paragraph>
			</div>
			{!!showInstructionsRow && (
				<div className={styles.alarmRow}>
					<div className={styles.tab}></div>
					<ReadOutlined className={styles.instructionIcon} />
					<Paragraph className={cx(styles.text, styles.ellipsis)} ellipsis={instructionsEllipsisConfig}>
						{instructions}
						{customShowMore && <span>... {showMoreButton}</span>}
					</Paragraph>
				</div>
			)}
		</div>
	);
};

export { AlarmContent };
